module.exports = __webpack_public_path__ + "media/iconic/key-cae2d388.svg";